
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11826',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11826",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.294",
  "data-fetching-client": "static-1.9551",
  "foundations-components": "static-1.7668",
  "foundations-components-legacy": "static-1.693",
  "foundations-theming": "static-1.4285",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7886",
  "hub-http-shared-msw-handlers": "static-1.9667",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11318",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6345",
  "marketplace-storefront-base": "static-1.11887",
  "quartz": "static-1.6833",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16528",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2738",
  "reporting-testing-lib": "static-1.8812",
  "settings-ui-lib": "static-1.12398",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6897",
  "ui-addon-i18n": "static-1.11021",
  "ui-addon-react-router-dom": "static-1.9420",
  "unified-auth": "static-1.310",
  "unified-auth-core-lib": "static-1.591",
  "usage-tracker": "static-1.7211",
  "usage-tracker-core": "static-1.7061",
  "customer-data-property-utils": "static-1.7957",
  "history": "static-4.47",
  "hub-http": "static-1.6094",
  "integrations-lib": "static-1.15684",
  "marketplace-ui-common": "static-1.19199",
  "property-management-iframe": "static-1.12689",
  "quartz-config": "static-1.611",
  "quartz-core": "static-1.6052",
  "quartz-routing": "static-1.263",
  "quick-fetch": "static-1.3808",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4519",
  "ts-schema": "static-1.3975",
  "ui-universal-auth": "static-1.8796",
  "UIComponents": "static-3.8265",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3302",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3110",
  "quartz-webpack": "static-1.3057",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3937",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4715",
  "foundations-theming-specialty": "static-1.2001",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9302",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5243",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1437",
  "ui-fonts": "static-1.580",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2768",
  "foundations-theming-base": "static-1.3270",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.2997",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4200",
  "ai-components-ui-library": "static-1.8595",
  "ai-rendering-library": "static-1.9597",
  "chirp-fetch": "static-1.1757",
  "connections-embed-lib": "static-1.742",
  "copilot-toolkit": "static-1.10758",
  "laboratory-lib": "static-3.7035",
  "marketplace-embed": "static-1.21699",
  "marketplace-ui-details": "static-1.9095",
  "marketplace-ui-reviews": "static-1.19155",
  "marketplace-ui-tracking": "static-1.13370",
  "sanitize-text": "static-1.8020",
  "ui-addon-video-player": "static-1.8569",
  "usage-tracker-multi": "static-1.5625",
  "usage-tracker-session-replay": "static-1.4897",
  "wootric-nps": "static-1.6858",
  "apollo-link-hub-http": "static-2.4526",
  "immer": "static-1.33",
  "immerable": "static-1.4028",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2416",
  "reporting-data": "static-1.66879",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11626",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10085",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10249",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7201",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17732",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4395",
  "foundations-components-test-utils": "static-1.5151",
  "quartz-i18n": "static-1.508",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3606",
  "customer-data-objects": "static-1.7529",
  "property-translator": "static-1.5283",
  "frontend-preferences-client": "static-1.7799",
  "hs-promise-utils": "static-1.5470",
  "hubspot-apollo-client": "static-1.4754",
  "integrations-error-boundary-lib": "static-1.13099",
  "integrations-tracking-lib": "static-1.5467",
  "native-integrations-shared-strings": "static-1.7661",
  "reselect": "static-2.16",
  "sanitize": "static-1.4349",
  "superstore": "static-1.4643",
  "ui-shepherd-react": "static-3.10021",
  "ai-settings-ui-library": "static-1.7675",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4548",
  "immutable-less": "static-1.4528",
  "marketplace-ui-client-types": "static-1.16606",
  "nav-meta": "static-1.29194",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10117",
  "ui-addon-upgrades": "static-9.17788",
  "inbound-db-properties-service-client": "static-1.3741",
  "property-management-common": "static-1.4977",
  "ui-addon-iframeable": "static-1.8923",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.508",
  "quartz-head": "static-1.498",
  "quartz-test": "static-1.508",
  "quartz-tracking": "static-1.212",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3041",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20690",
  "ContentUtils": "static-1.67887",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2368",
  "customer-data-filters-ui": "static-1.39207",
  "customer-data-objects-ui-components": "static-1.12891",
  "customer-data-reference-ui-components": "static-1.13026",
  "embedded-academy-lib": "static-1.13851",
  "ExportDialog": "static-6.10264",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40878",
  "reporting-snowflake": "static-1.55497",
  "reporting-ui-components": "static-2.64150",
  "reporting-visualizations": "static-1.58955",
  "ui-addon-teams": "static-1.21365",
  "magpie-lib": "static-1.5469",
  "magpie-types": "static-1.4929",
  "simple-logging-lib": "static-1.2925",
  "navigation-components": "static-1.17557",
  "ai-studio-lib": "static-1.11226",
  "app-governance-lib": "static-1.1137",
  "developer-experience-shared-components": "static-1.10377",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7866",
  "ui-product-approvals": "static-1.27738",
  "ui-tool-access": "static-1.10020",
  "usage-based-billing-components-lib": "static-1.8245",
  "usage-tracker-anonymous": "static-1.5628",
  "usage-tracker-public": "static-1.7022",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3584",
  "reference-resolvers": "static-1.8041",
  "ui-extensibility-client-types": "static-1.3815",
  "hubspot-apollo-cache": "static-1.213",
  "universal-page-editor-lib": "static-1.2878",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2407",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4945",
  "purchase-motions-components": "static-1.5628",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1427",
  "crm-component-utils": "static-1.38703",
  "crm-properties-common-lib": "static-1.5749",
  "customer-data-properties": "static-1.51063",
  "framework-data-schema-resolvers": "static-1.6748",
  "property-value-citations": "static-1.1677",
  "reference-resolvers-lite": "static-1.7962",
  "navigation-messaging": "static-1.6884",
  "hubspotter-http-shared-msw-handlers": "static-1.9665",
  "cms-field-types": "static-1.4683",
  "content-icons-ui": "static-1.2188",
  "conversations-skeleton-state": "static-1.7123",
  "crm-message-bus": "static-1.42622",
  "customer-data-filters-ui-msw-helpers": "static-1.21642",
  "customer-data-ui-utilities": "static-1.9699",
  "FormUrlGenerator": "static-2.4595",
  "framework-builder-read-service-client": "static-1.3903",
  "framework-data-schema-quick-fetch": "static-1.6653",
  "multi-account-reference-resolvers": "static-1.855",
  "onboarding-tours": "static-1.16372",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13295",
  "academy-common-lib": "static-1.13311",
  "content-assistance-lib": "static-1.7559",
  "dashboard-lib": "static-1.80975",
  "file-manager-components": "static-1.23182",
  "getting-started-shared-tasks": "static-1.18119",
  "hubspot-prosemirror": "static-1.17851",
  "hubspot-prosemirror-plugins": "static-1.17843",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19610",
  "share-with-third-party-component-lib": "static-1.8568",
  "ui-addon-draggable": "static-3.4643",
  "ui-asset-management-lib": "static-1.10832",
  "ui-business-units-lib": "static-1.8910",
  "user-context": "static-1.4975",
  "growth-payments-core": "static-1.24970",
  "reporting-plugins": "static-1.10084",
  "reporting-reports": "static-1.66557",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.599",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29040",
  "react-codemirror": "static-1.10499",
  "framework-listing-lib": "static-2.28280",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30345",
  "apps-service-types": "static-1.3752",
  "oauth-service-types": "static-1.4122",
  "onboarding-scopes": "static-1.6338",
  "onboarding-tours-client": "static-1.4586",
  "platform-infra-nav-components": "static-1.7562",
  "subscription-experience-data-types": "static-1.14690",
  "crm-record-cards-service-types": "static-1.3512",
  "location-customization-utils-lib": "static-1.8827",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4373",
  "nav-client-types": "static-1.2232",
  "purchase-motions-api": "static-1.5631",
  "signup-constants": "static-1.18589",
  "signup-ui-url-generator": "static-2.7911",
  "trials-service-types": "static-1.3774",
  "card-properties-lib": "static-1.43771",
  "commerce-subscription-lib": "static-1.36704",
  "crm-actions": "static-1.6186",
  "crm-cards-sdk": "static-1.43178",
  "customer-data-properties-shared-msw-handlers": "static-1.8994",
  "customer-data-tracking": "static-1.6758",
  "hs-resources": "static-1.8",
  "pulse": "static-1.406",
  "calling-global-api": "static-1.63993",
  "calling-internal-common": "static-1.31175",
  "calling-lifecycle-internal": "static-1.65375",
  "calling-lifecycle-messages": "static-1.57669",
  "commerce-products-lib": "static-1.9071",
  "conditional-properties-service-client": "static-1.3693",
  "crm-links": "static-1.6146",
  "external-options-client-types": "static-1.4054",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4118",
  "meetings-icalendar-utils-lib": "static-1.506",
  "multi-currency-client-types": "static-1.3585",
  "object-builder-ui-client": "static-1.48297",
  "pipeline-validation-client-types": "static-1.3859",
  "smart-property-lib": "static-1.6286",
  "tiered-pricing": "static-1.963",
  "ui-addon-form-validation": "static-1.10867",
  "crm-pipelines-api-client-types": "static-1.4037",
  "react-dnd-compat": "static-1.4494",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5235",
  "growth-onboarding-confetti": "static-1.2947",
  "growth-onboarding-next-action-utils": "static-1.1526",
  "onboarding-tours-utils": "static-1.438",
  "ui-shepherd-tracker": "static-1.7402",
  "academy-service-client": "static-1.3555",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28167",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8258",
  "video-components-external": "static-1.10834",
  "video-data-lib": "static-1.34492",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8433",
  "payment-link-components": "static-1.23159",
  "ui-addon-emoji-picker": "static-1.9762",
  "EmailSignatureEditor": "static-1.24075",
  "viral-links-lib": "static-1.6916",
  "data-token-picker": "static-1.16181",
  "FileManagerLib": "static-1.38822",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5119",
  "getting-started-shared-tasks-store": "static-1.17237",
  "campaign-roi-lib": "static-1.8539",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7198",
  "customer-data-views-management": "static-1.25156",
  "framework-data-table": "static-2.11597",
  "marketing-platform-lib": "static-1.6722",
  "nudge-client-utils": "static-1.2308",
  "nudge-custom-ui-functions": "static-1.808",
  "app-users-service-client": "static-1.5421",
  "app-users-service-types": "static-1.4829",
  "mini-checkout-client": "static-1.26508",
  "onboarding-utils": "static-1.5225",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28152",
  "edison-service-client-types": "static-1.267",
  "eligibility-engine-service-types": "static-1.3055",
  "crm_data": "static-4.91527",
  "customer-data-sidebar": "static-2.45640",
  "enrichment-properties-lib": "static-1.15404",
  "commerce-billing-lib": "static-1.18716",
  "commerce-shared-components-lib": "static-1.18177",
  "commerce-tools-ui-lib": "static-1.10016",
  "crm-fe-perf": "static-1.22778",
  "directed-graph": "static-1.813",
  "event-emitter": "static-1.822",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31181",
  "shared-worker-versioning": "static-1.10914",
  "calling-usage-tracker": "static-1.6416",
  "voice-sms-access-library": "static-1.497",
  "commerce-permissions": "static-1.639",
  "products-iframe-lib": "static-1.7559",
  "products-ui-components-shared-msw-handlers": "static-1.10049",
  "breeze-intelligence-kit": "static-1.5432",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9750",
  "policy-lib": "static-1.6654",
  "react-tinymce": "static-1.54863",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9813",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53989",
  "tinymce-plugins": "static-1.57103",
  "tinymce-themes": "static-1.55959",
  "growth-onboarding-next-action-components": "static-1.1554",
  "user-context-client": "static-1.4487",
  "growth-onboarding-feedback-components": "static-1.6456",
  "content-media-composition-data-lib": "static-1.11780",
  "content-media-compositions": "static-2.15787",
  "media-bridge-lib": "static-1.18701",
  "commerce-tours-lib": "static-1.5856",
  "growth-onboarding-reliability": "static-1.4961",
  "sales-checkout-service-client": "static-1.3543",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21448",
  "sales-email-signature-service-client": "static-1.3718",
  "audio-components": "static-1.5722",
  "FileManagerCore": "static-1.38681",
  "FileManagerImages": "static-1.36333",
  "video-components": "static-1.12837",
  "crm-export-dialog": "static-1.6169",
  "crm-index-associations-lib": "static-1.6311",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1548",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2065",
  "nudge-renderer-utils": "static-1.2384",
  "whisper-core-api": "static-1.6225",
  "InboxConnectUtils": "static-4.14443",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5240",
  "settings-content-modals": "static-1.45697",
  "crm_universal": "static-1.21783",
  "customer-data-email": "static-1.17808",
  "card-payment-highlight-lib": "static-1.36756",
  "card-subscription-highlight-lib": "static-1.39127",
  "commerce-contract-lib": "static-1.11504",
  "invoices-highlight-card-lib": "static-1.54267",
  "orders-highlight-card-lib": "static-1.21087",
  "products-highlight-card-lib": "static-1.17355",
  "quotes-highlight-card-lib": "static-1.71488",
  "crm-source-interpretation-lib": "static-1.5207",
  "utility-belt": "static-1.2415",
  "payments-enrollment-embed-lib": "static-1.22248",
  "customer-data-rte": "static-1.32651",
  "cv-backend-services": "static-1.1531",
  "growth-onboarding-empty-states": "static-1.5483",
  "payments-post-enroll-local-storage-lib": "static-1.4987",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37578",
  "calling-orchestration-schema": "static-1.35274",
  "sales-views-client-types": "static-1.4138",
  "hub-http-contrib": "static-1.2918",
  "interframe": "static-3.4637",
  "tinymce-data": "static-1.40074",
  "ui-addon-sales-email": "static-1.5087",
  "layout-dnd-components": "static-1.12197",
  "layout-dnd-utils": "static-1.11172",
  "ui-brand-identity-lib": "static-1.14486",
  "NamespacedHubStyle": "static-2.8964",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4407",
  "video-embed": "static-1.35326",
  "social-insights-client-types": "static-1.21667",
  "deal-intel-utils": "static-1.1552",
  "checkout-sdk": "static-3.23351",
  "checkout-service-types": "static-1.3721",
  "company-details-components": "static-1.6061",
  "payment-method-components": "static-1.6771",
  "pricing-pages-ui-components": "static-1.13072",
  "quote-checkout-service-types": "static-1.3358",
  "upgrade-catalog-service-types": "static-1.3401",
  "access-control-lib": "static-1.10312",
  "EmailComponents": "static-1.54375",
  "EmailData": "static-1.53052",
  "redux-less": "static-2.9360",
  "sequences-lib": "static-1.7821",
  "ui-gdpr-components": "static-1.10223",
  "products-ui-components": "static-1.39590",
  "quotes-ui-lib": "static-1.80209",
  "accounting-integrations-ui-components": "static-1.6859",
  "invoices-ui-lib": "static-1.54283",
  "commerce-products-api": "static-1.2089",
  "invoices-iframe-lib": "static-1.56341",
  "quotes-modal-lib": "static-1.102166",
  "stripe-embedded-components": "static-1.7279",
  "draft-content-plugins": "static-1.27919",
  "ContentData": "static-1.67962",
  "layout-data-lib": "static-1.9497",
  "outpost": "static-1.4073",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3804",
  "billing-payments-client-types": "static-1.3863",
  "account-and-billing-fintech-outages": "static-3.18344",
  "pricing-pages-api": "static-1.12937",
  "ContentComponents": "static-2.70843",
  "marketing-contacts-lib": "static-1.9407",
  "marketing-email-service-types": "static-1.1824",
  "messaging-editing-lib": "static-1.45858",
  "messaging-usage-based-billing-components-lib": "static-1.720",
  "automation-ui-source-apps": "static-1.18465",
  "automation-ui-types": "static-1.19383",
  "messaging-types-lib": "static-1.45595",
  "onboarding-settings-client": "static-1.4379",
  "sequences-client-types-lib": "static-1.7678",
  "commerce-tax-lib": "static-1.393",
  "property-description-translator": "static-1.3729",
  "SalesContentIndexUI": "static-3.9032",
  "commerce-analytics-service-client": "static-1.3531",
  "totals-ui-components": "static-1.23208",
  "stripe-connect-js": "static-1.66",
  "advanced-menus-core": "static-1.14929",
  "advanced-menus-lib": "static-1.11895",
  "ui-memberships-settings-lib": "static-1.33675",
  "demographics-service-types": "static-1.1523",
  "automation-ui-ubb": "static-1.5299",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7215",
  "data-token-views": "static-1.16162",
  "forms-utils-lib": "static-1.12334",
  "payments-embed-points-lib": "static-1.12772",
  "simple-menus-core": "static-1.14928",
  "simple-menus-lib": "static-1.16445",
  "ui-addon-draggable-compat": "static-2.4129",
  "videoconference-integration-components": "static-1.6637",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76744",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13541",
  "web-interactives-data": "static-1.13542",
  "messaging-shared-utils-lib": "static-1.169",
  "messaging-user-info-utils-lib": "static-1.339",
  "email-portal-health-service-types": "static-1.851",
  "FireAlarmUi": "static-1.4404",
  "sales-templates-service-types-lib": "static-1.4062",
  "commerce-totals-service-types": "static-1.3711",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21319",
  "automation-ui-usage-tracking": "static-1.20782",
  "data-studio-ubb": "static-1.2339",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26643",
  "collaboration-sidebar": "static-1.57375",
  "content-management-data-lib": "static-1.5220",
  "copilot-plugins": "static-1.10731",
  "cta-picker": "static-1.36051",
  "customer-agent-discovery-components-lib": "static-1.2668",
  "editor-components": "static-1.13045",
  "editor-iframe-lib": "static-1.8225",
  "error-messaging-js": "static-1.5065",
  "FormsCommonComponents": "static-1.85500",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10520",
  "SharedLegalStrings": "static-1.1627",
  "smart-content-core": "static-1.42080",
  "smart-content-lib": "static-1.42733",
  "social-composer-lib": "static-1.58460",
  "structured-content-lib": "static-1.24836",
  "theme-previewer-lib": "static-1.52889",
  "tinymce-copilot": "static-1.16057",
  "xray-recommendation-lib": "static-1.7713",
  "automation-ui-routing": "static-1.20740",
  "sql-reporting-client-types": "static-1.5539",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41857",
  "campaigns-utils-lib": "static-1.3030",
  "reporting-enablement": "static-1.22389",
  "chatspot-widget-iframe": "static-1.20682",
  "collaboration-sidebar-common": "static-1.2172",
  "forms-ai-lib": "static-1.4119",
  "codemirror-dlb": "static-1.58303",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6303",
  "report-customization-components": "static-1.12754",
  "data-quality-ui-library": "static-1.12536",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1320"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11826",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.294",
  "data-fetching-client": "/data-fetching-client/static-1.9551",
  "foundations-components": "/foundations-components/static-1.7668",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.693",
  "foundations-theming": "/foundations-theming/static-1.4285",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7886",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9667",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11318",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6345",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11887",
  "quartz": "/quartz/static-1.6833",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16528",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2738",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8812",
  "settings-ui-lib": "/settings-ui-lib/static-1.12398",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6897",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11021",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9420",
  "unified-auth": "/unified-auth/static-1.310",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.591",
  "usage-tracker": "/usage-tracker/static-1.7211",
  "usage-tracker-core": "/usage-tracker-core/static-1.7061",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7957",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6094",
  "integrations-lib": "/integrations-lib/static-1.15684",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19199",
  "property-management-iframe": "/property-management-iframe/static-1.12689",
  "quartz-config": "/quartz-config/static-1.611",
  "quartz-core": "/quartz-core/static-1.6052",
  "quartz-routing": "/quartz-routing/static-1.263",
  "quick-fetch": "/quick-fetch/static-1.3808",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4519",
  "ts-schema": "/ts-schema/static-1.3975",
  "ui-universal-auth": "/ui-universal-auth/static-1.8796",
  "UIComponents": "/UIComponents/static-3.8265",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3302",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3110",
  "quartz-webpack": "/quartz-webpack/static-1.3057",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3937",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4715",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2001",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9302",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5243",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1437",
  "ui-fonts": "/ui-fonts/static-1.580",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2768",
  "foundations-theming-base": "/foundations-theming-base/static-1.3270",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2997",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4200",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8595",
  "ai-rendering-library": "/ai-rendering-library/static-1.9597",
  "chirp-fetch": "/chirp-fetch/static-1.1757",
  "connections-embed-lib": "/connections-embed-lib/static-1.742",
  "copilot-toolkit": "/copilot-toolkit/static-1.10758",
  "laboratory-lib": "/laboratory-lib/static-3.7035",
  "marketplace-embed": "/marketplace-embed/static-1.21699",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9095",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19155",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13370",
  "sanitize-text": "/sanitize-text/static-1.8020",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8569",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5625",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4897",
  "wootric-nps": "/wootric-nps/static-1.6858",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4526",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4028",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2416",
  "reporting-data": "/reporting-data/static-1.66879",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11626",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10085",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10249",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7201",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17732",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4395",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5151",
  "quartz-i18n": "/quartz-i18n/static-1.508",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3606",
  "customer-data-objects": "/customer-data-objects/static-1.7529",
  "property-translator": "/property-translator/static-1.5283",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7799",
  "hs-promise-utils": "/hs-promise-utils/static-1.5470",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4754",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13099",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5467",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7661",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4349",
  "superstore": "/superstore/static-1.4643",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10021",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7675",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4548",
  "immutable-less": "/immutable-less/static-1.4528",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16606",
  "nav-meta": "/nav-meta/static-1.29194",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10117",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17788",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3741",
  "property-management-common": "/property-management-common/static-1.4977",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8923",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.508",
  "quartz-head": "/quartz-head/static-1.498",
  "quartz-test": "/quartz-test/static-1.508",
  "quartz-tracking": "/quartz-tracking/static-1.212",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20690",
  "ContentUtils": "/ContentUtils/static-1.67887",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2368",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39207",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12891",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13026",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13851",
  "ExportDialog": "/ExportDialog/static-6.10264",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40878",
  "reporting-snowflake": "/reporting-snowflake/static-1.55497",
  "reporting-ui-components": "/reporting-ui-components/static-2.64150",
  "reporting-visualizations": "/reporting-visualizations/static-1.58955",
  "ui-addon-teams": "/ui-addon-teams/static-1.21365",
  "magpie-lib": "/magpie-lib/static-1.5469",
  "magpie-types": "/magpie-types/static-1.4929",
  "simple-logging-lib": "/simple-logging-lib/static-1.2925",
  "navigation-components": "/navigation-components/static-1.17557",
  "ai-studio-lib": "/ai-studio-lib/static-1.11226",
  "app-governance-lib": "/app-governance-lib/static-1.1137",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10377",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7866",
  "ui-product-approvals": "/ui-product-approvals/static-1.27738",
  "ui-tool-access": "/ui-tool-access/static-1.10020",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8245",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5628",
  "usage-tracker-public": "/usage-tracker-public/static-1.7022",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3584",
  "reference-resolvers": "/reference-resolvers/static-1.8041",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3815",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.213",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2878",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2407",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4945",
  "purchase-motions-components": "/purchase-motions-components/static-1.5628",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1427",
  "crm-component-utils": "/crm-component-utils/static-1.38703",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5749",
  "customer-data-properties": "/customer-data-properties/static-1.51063",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6748",
  "property-value-citations": "/property-value-citations/static-1.1677",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7962",
  "navigation-messaging": "/navigation-messaging/static-1.6884",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9665",
  "cms-field-types": "/cms-field-types/static-1.4683",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7123",
  "crm-message-bus": "/crm-message-bus/static-1.42622",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21642",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9699",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4595",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3903",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6653",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.855",
  "onboarding-tours": "/onboarding-tours/static-1.16372",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13295",
  "academy-common-lib": "/academy-common-lib/static-1.13311",
  "content-assistance-lib": "/content-assistance-lib/static-1.7559",
  "dashboard-lib": "/dashboard-lib/static-1.80975",
  "file-manager-components": "/file-manager-components/static-1.23182",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18119",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17851",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17843",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19610",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8568",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4643",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10832",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8910",
  "user-context": "/user-context/static-1.4975",
  "growth-payments-core": "/growth-payments-core/static-1.24970",
  "reporting-plugins": "/reporting-plugins/static-1.10084",
  "reporting-reports": "/reporting-reports/static-1.66557",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.599",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29040",
  "react-codemirror": "/react-codemirror/static-1.10499",
  "framework-listing-lib": "/framework-listing-lib/static-2.28280",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30345",
  "apps-service-types": "/apps-service-types/static-1.3752",
  "oauth-service-types": "/oauth-service-types/static-1.4122",
  "onboarding-scopes": "/onboarding-scopes/static-1.6338",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4586",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7562",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14690",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3512",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8827",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4373",
  "nav-client-types": "/nav-client-types/static-1.2232",
  "purchase-motions-api": "/purchase-motions-api/static-1.5631",
  "signup-constants": "/signup-constants/static-1.18589",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7911",
  "trials-service-types": "/trials-service-types/static-1.3774",
  "card-properties-lib": "/card-properties-lib/static-1.43771",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36704",
  "crm-actions": "/crm-actions/static-1.6186",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43178",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8994",
  "customer-data-tracking": "/customer-data-tracking/static-1.6758",
  "hs-resources": "/hs-resources/static-1.8",
  "pulse": "/pulse/static-1.406",
  "calling-global-api": "/calling-global-api/static-1.63993",
  "calling-internal-common": "/calling-internal-common/static-1.31175",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65375",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57669",
  "commerce-products-lib": "/commerce-products-lib/static-1.9071",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3693",
  "crm-links": "/crm-links/static-1.6146",
  "external-options-client-types": "/external-options-client-types/static-1.4054",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4118",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.506",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3585",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48297",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3859",
  "smart-property-lib": "/smart-property-lib/static-1.6286",
  "tiered-pricing": "/tiered-pricing/static-1.963",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10867",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4037",
  "react-dnd-compat": "/react-dnd-compat/static-1.4494",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5235",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2947",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1526",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.438",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7402",
  "academy-service-client": "/academy-service-client/static-1.3555",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28167",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8258",
  "video-components-external": "/video-components-external/static-1.10834",
  "video-data-lib": "/video-data-lib/static-1.34492",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8433",
  "payment-link-components": "/payment-link-components/static-1.23159",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9762",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24075",
  "viral-links-lib": "/viral-links-lib/static-1.6916",
  "data-token-picker": "/data-token-picker/static-1.16181",
  "FileManagerLib": "/FileManagerLib/static-1.38822",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5119",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17237",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8539",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7198",
  "customer-data-views-management": "/customer-data-views-management/static-1.25156",
  "framework-data-table": "/framework-data-table/static-2.11597",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6722",
  "nudge-client-utils": "/nudge-client-utils/static-1.2308",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.808",
  "app-users-service-client": "/app-users-service-client/static-1.5421",
  "app-users-service-types": "/app-users-service-types/static-1.4829",
  "mini-checkout-client": "/mini-checkout-client/static-1.26508",
  "onboarding-utils": "/onboarding-utils/static-1.5225",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28152",
  "edison-service-client-types": "/edison-service-client-types/static-1.267",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3055",
  "crm_data": "/crm_data/static-4.91527",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45640",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15404",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18716",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18177",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10016",
  "crm-fe-perf": "/crm-fe-perf/static-1.22778",
  "directed-graph": "/directed-graph/static-1.813",
  "event-emitter": "/event-emitter/static-1.822",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31181",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10914",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6416",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.497",
  "commerce-permissions": "/commerce-permissions/static-1.639",
  "products-iframe-lib": "/products-iframe-lib/static-1.7559",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10049",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5432",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9750",
  "policy-lib": "/policy-lib/static-1.6654",
  "react-tinymce": "/react-tinymce/static-1.54863",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9813",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53989",
  "tinymce-plugins": "/tinymce-plugins/static-1.57103",
  "tinymce-themes": "/tinymce-themes/static-1.55959",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1554",
  "user-context-client": "/user-context-client/static-1.4487",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6456",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11780",
  "content-media-compositions": "/content-media-compositions/static-2.15787",
  "media-bridge-lib": "/media-bridge-lib/static-1.18701",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5856",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4961",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3543",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21448",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3718",
  "audio-components": "/audio-components/static-1.5722",
  "FileManagerCore": "/FileManagerCore/static-1.38681",
  "FileManagerImages": "/FileManagerImages/static-1.36333",
  "video-components": "/video-components/static-1.12837",
  "crm-export-dialog": "/crm-export-dialog/static-1.6169",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6311",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1548",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2065",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2384",
  "whisper-core-api": "/whisper-core-api/static-1.6225",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14443",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5240",
  "settings-content-modals": "/settings-content-modals/static-1.45697",
  "crm_universal": "/crm_universal/static-1.21783",
  "customer-data-email": "/customer-data-email/static-1.17808",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36756",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39127",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11504",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54267",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21087",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17355",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71488",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5207",
  "utility-belt": "/utility-belt/static-1.2415",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22248",
  "customer-data-rte": "/customer-data-rte/static-1.32651",
  "cv-backend-services": "/cv-backend-services/static-1.1531",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5483",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4987",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37578",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35274",
  "sales-views-client-types": "/sales-views-client-types/static-1.4138",
  "hub-http-contrib": "/hub-http-contrib/static-1.2918",
  "interframe": "/interframe/static-3.4637",
  "tinymce-data": "/tinymce-data/static-1.40074",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5087",
  "layout-dnd-components": "/layout-dnd-components/static-1.12197",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11172",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14486",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8964",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4407",
  "video-embed": "/video-embed/static-1.35326",
  "social-insights-client-types": "/social-insights-client-types/static-1.21667",
  "deal-intel-utils": "/deal-intel-utils/static-1.1552",
  "checkout-sdk": "/checkout-sdk/static-3.23351",
  "checkout-service-types": "/checkout-service-types/static-1.3721",
  "company-details-components": "/company-details-components/static-1.6061",
  "payment-method-components": "/payment-method-components/static-1.6771",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13072",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3358",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3401",
  "access-control-lib": "/access-control-lib/static-1.10312",
  "EmailComponents": "/EmailComponents/static-1.54375",
  "EmailData": "/EmailData/static-1.53052",
  "redux-less": "/redux-less/static-2.9360",
  "sequences-lib": "/sequences-lib/static-1.7821",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10223",
  "products-ui-components": "/products-ui-components/static-1.39590",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80209",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6859",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54283",
  "commerce-products-api": "/commerce-products-api/static-1.2089",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56341",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102166",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7279",
  "draft-content-plugins": "/draft-content-plugins/static-1.27919",
  "ContentData": "/ContentData/static-1.67962",
  "layout-data-lib": "/layout-data-lib/static-1.9497",
  "outpost": "/outpost/static-1.4073",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3804",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3863",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18344",
  "pricing-pages-api": "/pricing-pages-api/static-1.12937",
  "ContentComponents": "/ContentComponents/static-2.70843",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9407",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1824",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45858",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.720",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18465",
  "automation-ui-types": "/automation-ui-types/static-1.19383",
  "messaging-types-lib": "/messaging-types-lib/static-1.45595",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4379",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7678",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.393",
  "property-description-translator": "/property-description-translator/static-1.3729",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9032",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3531",
  "totals-ui-components": "/totals-ui-components/static-1.23208",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "advanced-menus-core": "/advanced-menus-core/static-1.14929",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11895",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33675",
  "demographics-service-types": "/demographics-service-types/static-1.1523",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5299",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7215",
  "data-token-views": "/data-token-views/static-1.16162",
  "forms-utils-lib": "/forms-utils-lib/static-1.12334",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12772",
  "simple-menus-core": "/simple-menus-core/static-1.14928",
  "simple-menus-lib": "/simple-menus-lib/static-1.16445",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4129",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6637",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76744",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13541",
  "web-interactives-data": "/web-interactives-data/static-1.13542",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.169",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.339",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.851",
  "FireAlarmUi": "/FireAlarmUi/static-1.4404",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4062",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3711",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21319",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20782",
  "data-studio-ubb": "/data-studio-ubb/static-1.2339",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26643",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57375",
  "content-management-data-lib": "/content-management-data-lib/static-1.5220",
  "copilot-plugins": "/copilot-plugins/static-1.10731",
  "cta-picker": "/cta-picker/static-1.36051",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2668",
  "editor-components": "/editor-components/static-1.13045",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8225",
  "error-messaging-js": "/error-messaging-js/static-1.5065",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85500",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10520",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1627",
  "smart-content-core": "/smart-content-core/static-1.42080",
  "smart-content-lib": "/smart-content-lib/static-1.42733",
  "social-composer-lib": "/social-composer-lib/static-1.58460",
  "structured-content-lib": "/structured-content-lib/static-1.24836",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52889",
  "tinymce-copilot": "/tinymce-copilot/static-1.16057",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7713",
  "automation-ui-routing": "/automation-ui-routing/static-1.20740",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5539",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41857",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3030",
  "reporting-enablement": "/reporting-enablement/static-1.22389",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20682",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2172",
  "forms-ai-lib": "/forms-ai-lib/static-1.4119",
  "codemirror-dlb": "/codemirror-dlb/static-1.58303",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6303",
  "report-customization-components": "/report-customization-components/static-1.12754",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12536",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1320"
}
};
